document.querySelectorAll('[data-splitting]').forEach(targetElement => {
  let splitResult = SplitType.create(targetElement, {
      types: 'chars',
      tagName: 'div'
  });

  // Apply --char-index to each character
  splitResult.chars.forEach((char, index) => {
      char.style.setProperty('--char-index', index);
  });
});

document.querySelectorAll(".mm-btn").forEach((button) => {
button.addEventListener("click", () => {
  button.classList.add("clicked");

  // Supprime la classe après l'animation pour pouvoir la rejouer à chaque clic
  setTimeout(() => {
    button.classList.remove("clicked");
  }, 750); // Doit correspondre à la durée de l'animation CSS (0.35s)
});
});

// LENIS
/* Lenis */
var lenis = new Lenis({
duration: 1.2,
easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
direction: 'vertical',
gestureDirection: 'vertical',
lerp: 0.06,
smooth: 2,
smoothTouch: false,
touchMultiplier: 2,
wheelMultiplier: 1,
infinite: false,
autoResize: true,
});

lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {

});

function raf(time) {
lenis.raf(time);
requestAnimationFrame(raf);
ScrollTrigger.update();
}

requestAnimationFrame(raf);

// Disable Lenis when overing div with overflow:scroll
function stopLenis() {
lenis.destroy();
}

// Fonction appelée quand la souris quitte l'élément
function startLenis() {
lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  direction: 'vertical',
  gestureDirection: 'vertical',
  lerp: 0.06,
  smooth: 2,
  smoothTouch: false,
  touchMultiplier: 2,
  wheelMultiplier: 1,
  infinite: false,
  autoResize: true,
});

lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {

});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
  ScrollTrigger.update();
}

requestAnimationFrame(raf);
}

var elements = document.querySelectorAll('.stop-lenis');

elements.forEach(function(element){
if (window.innerWidth > 768) {
  element.addEventListener('mouseenter', stopLenis);
  element.addEventListener('mouseleave', startLenis);
}
})

//const lenis = new Lenis({ autoRaf: true });

lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    gsap.config({ nullTargetWarn: false });

    randomizeShoeImages();
    animateShoesOnScroll();
    animateMarqueeImagesOnScroll();
    animateTestimonialCards();
    animateStepsCards();
    animateTimeline();

    // Applique les animations de type "marquee"
    createMarqueeScrollAnimation({
        containerSelector: '.mm-hero-marquee',
        contentSelector: '.mm-content-slide'
    });

    createMarqueeScrollAnimation({
        containerSelector: '.mm-marquee-container',
        contentSelector: '.mm-marquee-marquee .mm-marquee-slide'
    });

    // Rafraîchit les animations au resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            createMarqueeScrollAnimation({
                containerSelector: '.mm-hero-marquee',
                contentSelector: '.mm-content-slide'
            });

            createMarqueeScrollAnimation({
                containerSelector: '.mm-marquee-container',
                contentSelector: '.mm-marquee-marquee .mm-marquee-slide'
            });

            ScrollTrigger.refresh(true);
        }, 250);
    });
});

function createMarqueeScrollAnimation({ containerSelector, contentSelector }) {
    const container = document.querySelector(containerSelector);
    const content = document.querySelector(contentSelector);

    if (!container || !content) return;

    function getContainerWidth() {
        const viewportWidth = container.offsetWidth;
        return viewportWidth > 800 ? viewportWidth / 2 : viewportWidth;
    }

    const containerWidth = getContainerWidth();

    if (content._scrollTrigger) content._scrollTrigger.kill();
    if (content.animation) content.animation.kill();

    content.animation = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top 100%",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true,
            onRefresh: () => {
                const newWidth = getContainerWidth();
                gsap.set(content, {
                    x: gsap.utils.interpolate(0, -newWidth, content._scrollTrigger.progress)
                });
            }
        }
    });

    content._scrollTrigger = content.animation.scrollTrigger;

    content.animation.to(content, {
        x: -containerWidth,
        ease: "none",
        duration: 1
    });
}

function animateShoesOnScroll() {
    const shoesContainer = document.querySelector('.mm-shoes-container');
    const hero = document.querySelector('.mm-hero');
    const shoes = [
        document.getElementById('shoe1'),
        document.getElementById('shoe2'),
        document.getElementById('shoe3'),
        document.getElementById('shoe4'),
        document.getElementById('shoe5'),
        document.getElementById('shoe6'),
        document.getElementById('shoe7'),
        document.getElementById('shoe8')
    ];

    shoes.forEach((shoe) => {
        if (shoe) {
            const style = window.getComputedStyle(shoe);
            const transform = style.transform || style.webkitTransform;
            const matrix = new DOMMatrix(transform);

            const initialRotation = Math.atan2(matrix.b, matrix.a) * (180 / Math.PI);
            const rotationChange = (Math.random() * 180) - 60;
            const translateYChange = 10 + (Math.random() * 20);
            const targetRotation = initialRotation + rotationChange;

            gsap.fromTo(shoe,
                {
                    rotation: initialRotation,
                    y: 0
                },
                {
                    rotation: targetRotation,
                    y: `${translateYChange}vh`,
                    ease: "power1.inOut",
                    scrollTrigger: {
                        trigger: hero,
                        start: "top top",
                        end: "bottom top",
                        scrub: 0.5,
                        invalidateOnRefresh: true
                    }
                }
            );
        }
    });
}

function randomizeShoeImages() {
    const shoes = [
        document.getElementById('shoe1'),
        document.getElementById('shoe2'),
        document.getElementById('shoe3'),
        document.getElementById('shoe4'),
        document.getElementById('shoe5'),
        document.getElementById('shoe6'),
        document.getElementById('shoe7'),
        document.getElementById('shoe8')
    ];

    if (!shoes[0]) return;

    const originalSources = shoes.map(shoe => shoe?.src || '');
    const shuffledSources = [...originalSources];

    for (let i = shuffledSources.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledSources[i], shuffledSources[j]] = [shuffledSources[j], shuffledSources[i]];
    }

    shoes.forEach((shoe, index) => {
        if (shoe) {
            shoe.src = shuffledSources[index];
            console.log(`Set ${shoe.id} to use image source: ${shuffledSources[index]}`);
        }
    });
}

function animateMarqueeImagesOnScroll() {
    const container = document.querySelector('.mm-marquee-images-container');

    if (!container) return;

    const image1 = document.querySelector('.mm-marquee-image-1');
    const image2 = document.querySelector('.mm-marquee-image-2');
    const image3 = document.querySelector('.mm-marquee-image-3');

    if (image1) {
        gsap.fromTo(image1,
            {
                y: 200,
                rotate: -3
            },
            {
                y: -50,
                rotate: -13,
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            }
        );
    }

    if (image2) {
        gsap.fromTo(image2,
            {
                y: 150
            },
            {
                y: -100,
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            }
        );
    }

    if (image3) {
        gsap.fromTo(image3,
            {
                y: 200,
                rotate: 3
            },
            {
                y: -50,
                rotate: 13,
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            }
        );
    }
}

function animateTestimonialCards() {
  const container = document.querySelector('.mm-avis-avis');
  const cards = gsap.utils.toArray('.mm-testimonial-card');
  if (!container || !cards.length) return;

  // Optimisation pour Safari - ajouter will-change
  cards.forEach(card => {
    card.style.willChange = 'transform, opacity';
  });

  // état initial - optimisé pour Safari
  gsap.set(cards, {
    y: 400,
    rotation: 7,
    scale: 1,
    opacity: 0,
    force3D: true // Force l'accélération matérielle
  });
  gsap.set(cards[0], { y: 0, rotation: 0, opacity: 1, force3D: true });

  // timeline pin optimisé
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start:  'top 20%',
      end:    'bottom 20%',
      scrub:  1.5, // Ralentir le scrub pour plus de fluidité
      pin:    true,
      pinSpacing: true, // Corriger le conflit de scroll
      anticipatePin: 1, // Optimisation pour Safari
      invalidateOnRefresh: true
    }
  });

  cards.slice(1).forEach((card, i) => {
    const idx    = i + 1;
    const offset = i * 1.8;            // Ralentir l'animation (1.2 -> 1.8)
    const transDuration   = 1.2;       // Ralentir (0.8 -> 1.2)
    const opacityDuration = transDuration * 0.6;  // Ajuster proportionnellement

    // 1) opacity - optimisé pour Safari
    tl.to(card, {
      opacity: 1,
      duration: opacityDuration,
      force3D: true
    }, offset);

    // 2) transform - optimisé pour Safari
    tl.to(card, {
      y:       0,
      rotation: -5 + idx,
      scale:    1 - 0.05 * (cards.length - idx - 1),
      ease:    'power2.out', // Easing plus performant que 'slow'
      duration: transDuration,
      force3D: true
    }, offset);
  });

  // Nettoyer will-change après l'animation
  ScrollTrigger.create({
    trigger: container,
    start: 'bottom 80%',
    onEnter: () => {
      cards.forEach(card => {
        card.style.willChange = 'auto';
      });
    }
  });
}

function animateTimeline() {
  gsap.registerPlugin(ScrollTrigger);

  const steps = document.querySelector(".steps");
  const step_elems = document.querySelectorAll('.step');
  const pinSection = document.querySelector(".pin-wrapper");
  const images = document.querySelector(".steps-images");

  if (!steps || !images || !pinSection) return;

  const stepsHeight = steps.scrollHeight;
  const imagesHeight = images.scrollHeight;
  const pinHeight = pinSection.offsetHeight;
  let contentHeight;

  const isMobile = window.innerWidth <= 768; // seuil mobile à ajuster si besoin

  // prendre la plus grande hauteur entre steps et images
  if (isMobile) {
    contentHeight = stepsHeight;
  } else {
    contentHeight = Math.max(stepsHeight, imagesHeight);
  }

  const scrollDistance = contentHeight - pinHeight;

  if (scrollDistance > 0) {
    // on réserve la place du seul scroll interne
    pinSection.style.paddingBottom = `75vh`;
  }

  ScrollTrigger.create({
    trigger: ".pin-wrapper",
    start: "top top",
    end: `+=${scrollDistance}`,
    pin: true,
    scrub: true,
    onUpdate: self => {
      const scrollAmount = -self.progress * scrollDistance;
      // animer steps
      gsap.to(steps, { y: scrollAmount, ease: "none", overwrite: "auto" });

      // animer images uniquement si ce n'est pas mobile
      if (!isMobile) {
        gsap.to(images, { y: scrollAmount * 0.5, ease: "none", overwrite: "auto" });
      } else {
        // reset position sur mobile si elle a été modifiée
        gsap.set(images, { y: 0 });
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // Options de l'observer : on déclenche dès que 10% de la section est visible
  const observerOptions = {
    root: null,
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Dès qu'une .mm-section-timeline entre dans la vue,
        // on force GSAP ScrollTrigger à se recalibrer
        ScrollTrigger.refresh();
      }
    });
  }, observerOptions);

  // On observe chaque section timeline
  document.querySelectorAll(".mm-section-timeline").forEach(section => {
    observer.observe(section);
  });
});



function animateStepsCards() {

  const isMobile = window.innerWidth <= 768; // seuil mobile à ajuster si besoin
  if (!isMobile) {
    return
  }

  const container = document.querySelector('.mm-steps-steps');
  const cards = gsap.utils.toArray('.mm-step-card');
  if (!container || !cards.length) return;

  // état initial
  gsap.set(cards, { y: 400, rotation: 7, scale: 1, opacity: 0 });
  gsap.set(cards[0], { y: 0, rotation: 0, opacity: 1 });

  // timeline pin à 20% du viewport
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start:  'top 20%',
      end:    'bottom 20%',
      scrub:  true,
      pin:    true,
      pinSpacing: false
    }
  });

  cards.slice(1).forEach((card, i) => {
    const idx    = i + 1;
    const offset = i * 1.2;            // chaque carte démarre à i*1.2
    const transDuration   = 0.8;       // durée pour y/rotation/scale
    const opacityDuration = transDuration / 2;  // moitié, pour finir plus vite

    // 1) opacity
    tl.to(card, {
      opacity: 1,
      duration: opacityDuration
    }, offset);

    // 2) transform
    tl.to(card, {
      y:       0,
      rotation: 0 + idx,
      ease:    'slow(0.7, 0.7, false)',
      duration: transDuration
    }, offset);
  });
}
